import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetUsersInGroupDocument,
  type GetUsersInGroupQuery,
  type GetUsersInGroupQueryVariables,
} from "~/features/admin/groups/gqls";

export function useGroupUsers(groupId: string) {
  return useSuspenseQuery<GetUsersInGroupQuery, GetUsersInGroupQueryVariables>(GetUsersInGroupDocument, {
    variables: { groupId },
  });
}
